// @flow
import type {ApplicationState} from '../../state/types'

import React, {Component} from 'react'
import {connect} from 'react-redux'

import {withTranslate} from '../translation'
import {sessionActions} from '../../state/session/actions'
import {sessionSelectors} from '../../state/session/selectors'

import {Notification} from '../common/Notification'

import './sign-in.css'

type Props = {
  error: ?string,
  isLoading: boolean,
  t: Function,
  onSignIn: (username: string, password: string) => void,
  onCloseError: () => void,
}

type State = {
  username: string,
  password: string,
}

class SignInForm extends Component<Props, State> {

  state = {
    username: '',
    password: '',
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleSubmit = (e) => {
    const {username, password} = this.state
    const {onSignIn, isLoading} = this.props
    if (!isLoading) {
      onSignIn(username, password)
    }
    e.preventDefault()
  }

  render() {
    const {error, isLoading, t, onCloseError} = this.props
    return (
      <div className="sign-in-form">
        {error && (
          <Notification
            message={t(`SignIn.error.${error}`)}
            className="is-danger"
            handleClose={onCloseError}
          />
        )}
        <form
          onSubmit={this.handleSubmit}
        >
          <h1>{t('SignIn.title')}</h1>
          <label>{t('SignIn.username.label')}</label>
          <input
            type="text"
            name="username"
            placeholder={t('SignIn.username.placeholder')}
            className="input"
            onChange={this.handleChange}
            required={true}
            autoFocus={true}
            autoComplete="off"
          />
          <label>{t('SignIn.password.label')}</label>
          <input
            type="password"
            name="password"
            className="input"
            onChange={this.handleChange}
          />
          <button type="submit" 
            className="button is-dark"
            disabled={isLoading}
            >
            {t('SignIn.submit')}
          </button>
        </form>
      </div>
    )
  }
}

const mapStateToProps = (state:ApplicationState):any => {
  return {
    error: sessionSelectors.getError(state),
    isLoading: sessionSelectors.isLoading(state),
  }
}

const mapDispatchToProps = (dispatch: Function):any => {
  return {
    onSignIn: (username: string, password: string) => {
      dispatch(sessionActions.signIn(username, password))
    },
    onCloseError: () => {
      dispatch(sessionActions.setError(null))
    },
  }
}

export default withTranslate(connect(mapStateToProps, mapDispatchToProps)(SignInForm))
